<template>
  <div>
    <button class="btn btn-sm btn-xs btn-success mr-2 font-weight-bolder"
            data-toggle="modal"
            data-target="#add-manning-vessel-history"
            v-if="(isSystemAdmin || isPrincipal || isPrincipalStaff || isDesignatedPrincipal) && !isKline"
    >
      <span class="fas fa-user"></span>
      Add Manning History Record
    </button>

    <cms-modal unique="add-manning-vessel-history" title="Add Manning History" size="lg">

      <form @submit.prevent="confirmAddManningVesselHistory">
        <div class="form-group form-row mb-1" :class="{'has-error': newVesselManningHistoryErrors.manning_from_id}">
          <label for="manning-from" class="col col-sm-3 col-form-label font-weight-bolder">
            From:
          </label>
          <div class="col col-sm-8 offset-1 col-form-label p-0">
            <select id="manning-from" class="form-control form-control-xs"
                    :class="{'bg-table-hover': otherFrom}"
                    v-model="newVesselManningHistory.manning_from_id"
                    @change="showOtherFrom"
            >
              <option class="bg-white" :value="undefined">--- Select Manning ---</option>
              <option class="bg-white" v-for="manningKey in allManningKeys" :key="manningKey.id"
                      :value="manningKey.id">
                {{ manningKey.name }}
              </option>
              <option value="" class="bg-warning" title="if manning is not in the list">--- OTHER MANNING---</option>
            </select>
            <span class="help-block" v-if="newVesselManningHistoryErrors.manning_from_id !== ''">
              <small><strong>{{ newVesselManningHistoryErrors.manning_from_id }}</strong></small>
            </span>
          </div>
        </div>

        <div class="form-group form-row mb-1"
             :class="{'has-error': newVesselManningHistoryErrors.other_manning_from}"
             v-if="otherFrom">
          <label for="other-management-from" class="col col-sm-3 col-form-label font-weight-bolder">
            Other:
          </label>

          <div class="col col-sm-8 offset-1 col-form-label p-0">
            <input type="text" id="other-management-from"
                   class="form-control form-control-xs"
                   placeholder="Specify Manning Name for this record"
                   v-model="newVesselManningHistory.other_manning_from"
            >
            <span class="help-block" v-if="newVesselManningHistoryErrors.other_manning_from !== ''">
              <small><strong>{{ newVesselManningHistoryErrors.other_manning_from }}</strong></small>
            </span>
          </div>
        </div>

        <div class="form-group form-row mb-1" :class="{'has-error': newVesselManningHistoryErrors.manning_to_id}">
          <label for="manning-to" class="col col-sm-3 col-form-label font-weight-bolder">
            To:
          </label>
          <div class="col col-sm-8 offset-1 col-form-label p-0">
            <select id="manning-to" class="form-control form-control-xs"
                    :class="{'bg-table-hover': otherTo}"
                    v-model="newVesselManningHistory.manning_to_id"
                    @change="showOtherTo"
            >
              <option class="bg-white" :value="undefined">--- Select Manning ---</option>
              <option class="bg-white" v-for="manningKey in allManningKeys" :key="manningKey.id"
                      :value="manningKey.id">
                {{ manningKey.name }}
              </option>
              <option value="" class="bg-warning" title="if manning is not in the list">--- OTHER MANNING ---</option>
            </select>
            <span class="help-block" v-if="newVesselManningHistoryErrors.manning_to_id !== ''">
              <small><strong>{{ newVesselManningHistoryErrors.manning_to_id }}</strong></small>
            </span>
          </div>
        </div>

        <div class="form-group form-row mb-1"
             :class="{'has-error': newVesselManningHistoryErrors.other_manning_to}"
             v-if="otherTo">
          <label for="other-management-from" class="col col-sm-3 col-form-label font-weight-bolder">
            Other:
          </label>

          <div class="col col-sm-8 offset-1 col-form-label p-0">
            <input type="text" id="other-management-to"
                   class="form-control form-control-xs"
                   placeholder="Specify Manning Name for this record"
                   v-model="newVesselManningHistory.other_manning_to"
            >
            <span class="help-block" v-if="newVesselManningHistoryErrors.other_manning_to !== ''">
              <small><strong>{{ newVesselManningHistoryErrors.other_manning_to }}</strong></small>
            </span>
          </div>
        </div>

<!--        <div class="form-group form-row mb-1" :class="{'has-error': newVesselManningHistoryErrors.date_from}">-->
<!--          <label for="new-date-from" class="col col-sm-3 col-form-label font-weight-bolder">-->
<!--            Date From:-->
<!--          </label>-->
<!--          <div class="col col-sm-8 offset-1 col-form-label p-0">-->
<!--            <input type="date" id="new-date-from"-->
<!--                   class="form-control form-control-xs"-->
<!--                   v-model="newVesselManningHistory.date_from"-->
<!--            >-->
<!--            <span class="help-block" v-if="newVesselManningHistoryErrors.date_from !== ''">-->
<!--                              <small><strong>{{ newVesselManningHistoryErrors.date_from }}</strong></small>-->
<!--                            </span>-->
<!--          </div>-->
<!--        </div>-->

<!--        <div class="form-group form-row mb-1" :class="{'has-error': newVesselManningHistoryErrors.date_to}">-->
<!--          <label for="new-date-to" class="col col-sm-3 col-form-label font-weight-bolder">-->
<!--            Date To:-->
<!--          </label>-->
<!--          <div class="col col-sm-8 offset-1 col-form-label p-0">-->
<!--            <input type="date" id="new-date-to"-->
<!--                   class="form-control form-control-xs"-->
<!--                   v-model="newVesselManningHistory.date_to"-->
<!--            >-->
<!--            <span class="help-block" v-if="newVesselManningHistoryErrors.date_to !== ''">-->
<!--                              <small><strong>{{ newVesselManningHistoryErrors.date_to }}</strong></small>-->
<!--                            </span>-->
<!--          </div>-->
<!--        </div>-->

        <div class="form-group form-row mb-1" :class="{'has-error': newVesselManningHistoryErrors.date_transferred}">
          <label for="new-date-transferred" class="col col-sm-3 col-form-label font-weight-bolder">
            Date Transferred:
          </label>
          <div class="col col-sm-8 offset-1 col-form-label p-0">
            <input type="date" id="new-date-transferred"
                   class="form-control form-control-xs"
                   v-model="newVesselManningHistory.date_transferred"
            >
            <span class="help-block" v-if="newVesselManningHistoryErrors.date_transferred !== ''">
              <small><strong>{{ newVesselManningHistoryErrors.date_transferred }}</strong></small>
            </span>
          </div>
        </div>

<!--        <div class="form-group form-row mb-1" :class="{'has-error': newVesselManningHistoryErrors.active}">-->
<!--          <label for="new-status" class="col col-sm-3 col-form-label font-weight-bolder">-->
<!--            Active:-->
<!--          </label>-->
<!--          <div class="col col-sm-8 offset-1 col-form-label p-0">-->
<!--            <select id="new-status" class="form-control form-control-xs"-->
<!--                    v-model="newVesselManningHistory.active"-->
<!--            >-->
<!--              <option value="1"> Active</option>-->
<!--              <option value="0"> Inactive</option>-->
<!--            </select>-->
<!--            <span class="help-block" v-if="newVesselManningHistoryErrors.active !== ''">-->
<!--                              <small><strong>{{ newVesselManningHistoryErrors.active }}</strong></small>-->
<!--                            </span>-->
<!--          </div>-->
<!--        </div>-->


        <button type="submit" class="btn btn-warning btn-sm btn-xs mr-3 font-weight-bolder float-right">
          <i class="fas fa-save"></i>
          Save
        </button>

      </form>


    </cms-modal>
  </div>
</template>

<script>
import CmsModal from '@/components/elements/CmsModal';
import {vueAppMixin} from '@/mixins/vueAppMixin';
import {formMixin} from '@/mixins/formMixin';
import {gateMixin} from '@/mixins/gateMixin';
import {mapActions, mapGetters} from 'vuex';

export default {
  name: 'AddManningHistory',

  mixins: [vueAppMixin, formMixin, gateMixin],

  components: {CmsModal},

  data() {
    return {
      newVesselManningHistory: {
        manning_from_id: undefined,
        other_manning_from: undefined,
        manning_to_id: undefined,
        other_manning_to: undefined,
      },
      newVesselManningHistoryErrors: {},

      otherFrom: false,
      otherTo: false,

    };
  },

  methods: {
    ...mapActions([
      'addVesselManningHistory',
    ]),

    async confirmAddManningVesselHistory() {
      if (await this.confirmCreateAlert()) {
        let params = {
          vessel_id: this.$route.params.id,

          manning_from_id: this.newVesselManningHistory.manning_from_id,
          other_manning_from: this.newVesselManningHistory.other_manning_from,

          manning_to_id: this.newVesselManningHistory.manning_to_id,
          other_manning_to: this.newVesselManningHistory.other_manning_to,

          date_transferred: this.newVesselManningHistory.date_transferred,
          // date_to: this.newVesselManningHistory.date_to,

        };
        let newVesselManningHistory = await this.addVesselManningHistory(params);
        if (newVesselManningHistory) {
          if (newVesselManningHistory.errors) {
            this.newVesselManningHistoryErrors = newVesselManningHistory.errors;
          } else {
            this.newVesselManningHistory = {};
            this.newVesselManningHistory.active = 1;
            this.otherFrom = false;
            this.otherTo = false;
            this.successAlert('Vessel Manning History Record Successfully Added', 'CREATE');
            document.getElementById('close-add-manning-vessel-history').click();
          }
        }
      }
    },

    showOtherFrom: function(e) {
      this.otherFrom = e.target.value === '';
    },

    showOtherTo: function(e) {
      this.otherTo = e.target.value === '';
    },

  },

  computed: {
    ...mapGetters([
      'allManningKeys',
      'vesselInfo',
    ]),
  },

  created() {
    //
  },

  destroyed() {
  },

  watch: {
    'newVesselManningHistory.other_manning_from'() {
      if (this.newVesselManningHistory.other_manning_from) {
        this.newVesselManningHistory.manning_from_id = undefined;
      }

    },

    'newVesselManningHistory.manning_from_id'() {
      if (this.newVesselManningHistory.manning_from_id) {
        this.newVesselManningHistory.other_manning_from = null;
      }
    },

    'newVesselManningHistory.other_manning_to'() {
      if (this.newVesselManningHistory.other_manning_to) {
        this.newVesselManningHistory.manning_to_id = undefined;
      }
    },

    'newVesselManningHistory.manning_to_id'() {
      if (this.newVesselManningHistory.manning_to_id) {
        this.newVesselManningHistory.other_manning_to = null;
      }
    },

  },

};
</script>

<style scoped>

</style>
